var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTutorialTriangle = function SvgTutorialTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.828 1.377 5.175 6.728a2.42 2.42 0 0 1-.442 3.393 2.42 2.42 0 0 1-1.476.502H3.218a2.42 2.42 0 0 1-2.42-2.42 2.42 2.42 0 0 1 .572-1.563l5.693-6.728a2.42 2.42 0 0 1 3.41-.284 2.42 2.42 0 0 1 .355.372Z",
    fill: "inherit",
    fillRule: "evenodd"
  })));
};
export default SvgTutorialTriangle;